module.exports = __webpack_public_path__ + "static/media/Country-Place-Amended-and-Restated.a5afb419.pdf";